export default __webpack_public_path__ + "static/01-67134253c08a9d8ceea4119ae8104322.jpg";